import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Info } from 'react-feather';
import AddToCartLoadingIcon from './add-to-cart-loading-icon';

export const AddCartButton = ({
  isPreOrder,
  isAddingProduct,
  addToCartStatus,
  label,
  isOutOfStock,
  isSoldOut,
  setNotifyMeFormDialogIsOpen,
  isSupportedProductType,
  showReadyToShip = true,
  className,
  showPreOrderTips = true,
  showNotifyMeTips = true,
  note,
  outerClassName = '',
}: any) => {
  const cartCallToActionPreOrderText = addToCartStatus ? (
    <div className='relative flex h-full w-full items-center justify-center px-5'>
      <span>ADDED</span>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        fill='none'
        viewBox='0 0 16 16'
        className='absolute right-0 top-1/2 block -translate-y-1/2'
      >
        <path
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M15 2 5.2 14 1 9.5'
        />
      </svg>
    </div>
  ) : isAddingProduct ? (
    <AddToCartLoadingIcon />
  ) : (
    <span>{label || 'PRE-ORDER'}</span>
  );

  const cartCallToActionText = addToCartStatus ? (
    <div className='relative flex h-full w-full items-center justify-center px-5'>
      <span>ADDED</span>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        fill='none'
        viewBox='0 0 16 16'
        className='absolute right-0 top-1/2 block -translate-y-1/2'
      >
        <path
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M15 2 5.2 14 1 9.5'
        />
      </svg>
    </div>
  ) : isAddingProduct ? (
    <AddToCartLoadingIcon />
  ) : isOutOfStock ? (
    'Notify Me'
  ) : (
    'Add to Cart'
  );

  if (isPreOrder) {
    return (
      <div className={cn('flex w-full flex-col gap-4', outerClassName)}>
        <Button
          type='submit'
          disabled={addToCartStatus || isAddingProduct}
          className={cn(
            'h-[40px] w-full rounded-[10px] font-poppins text-base font-semibold disabled_opacity-100 lg_h-[54px] lg_hover_bg-primary lg_hover_opacity-90',
            addToCartStatus ? 'bg-accent' : 'bg-primary',
            className,
          )}
        >
          {cartCallToActionPreOrderText}
        </Button>
      </div>
    );
  }

  if (isOutOfStock || isSoldOut) {
    return (
      <div className={cn('flex-1', 'flex flex-col gap-[5px]')}>
        <Button
          type='button'
          disabled={isSoldOut}
          className={cn(
            'h-[40px] w-full items-center lg_h-[54px]',
            'rounded-[10px] border-1 border-primary bg-white font-poppins font-[600] uppercase text-primary',
            !isSoldOut && 'hover_text-white',
            isSoldOut && 'disabled_opacity-100',
            className,
          )}
          onClick={() => {
            if (!isSoldOut) setNotifyMeFormDialogIsOpen(true);
          }}
        >
          {isSoldOut ? 'NO LONGER AVAILABLE' : 'Notify Me'}
        </Button>
      </div>
    );
  }

  return (
    <>
      {isSupportedProductType ? (
        <div className={cn('flex w-full flex-col gap-y-[5px] lg_gap-y-2.5', outerClassName)}>
          <Button
            type='submit'
            className={cn(
              'h-[40px] w-full rounded-[10px] font-poppins text-[16px] font-[600] uppercase hover_opacity-90 disabled_opacity-100 lg_h-[54px] lg_hover_bg-primary',
              addToCartStatus ? 'bg-accent' : 'bg-primary',
              className,
            )}
            disabled={addToCartStatus || isAddingProduct}
          >
            {cartCallToActionText}
          </Button>
        </div>
      ) : (
        <div
          className={cn(
            'bg-subtle',
            'gap-x-2xs',
            'grid',
            'grid-flow-col',
            'italic',
            'items-center',
            'justify-start',
            'p-3',
            'text-subtle',
            'w-full',
          )}
        >
          <Info />
          <p>This product is currently unavailable for purchase.</p>
        </div>
      )}
    </>
  );
};
